export default __webpack_public_path__ + "static/media/IMG_4553-min.2de22764.JPG";